import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function Dashboard() {
  const navigate = useNavigate();

  useEffect(() => {
    const authKey = sessionStorage.getItem("auth_key");
    const expiry = sessionStorage.getItem("session_expiry");
    const role = sessionStorage.getItem("user_level");

    if (!authKey || !expiry || Date.now() > parseInt(expiry)) {
      sessionStorage.clear();
      navigate("/login");
    }

    // Optional: Check if user is allowed to view this page
    if (role !== "admin" && role !== "member") {
      navigate("/not-authorized");
    }
  }, []);

  return (
    <div>
      <h1>Welcome to Dashboard</h1>
    </div>
  );
}

export default Dashboard;
